var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.alert.color},model:{value:(_vm.alert.visible),callback:function ($$v) {_vm.$set(_vm.alert, "visible", $$v)},expression:"alert.visible"}},[_vm._v(" "+_vm._s(_vm.alert.msg)+" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.alert.visible = false}}},[_vm._v("Fechar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }